<template>
  <div></div>
</template>

<script>
export default {
  data () {
    return {
      msg: "qw"
    };
  },
}

</script>
<style lang='scss' scoped>
</style>